// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__AZ2Wt","notes":"Notes_notes__1x6C3"};